"use client";
import { useState } from "react";
import Link from "next/link";
import { HeaderItem } from "../../../../../../types/menu";
import { usePathname } from "next/navigation";
import { ChevronDown } from "lucide-react";

const HeaderLink: React.FC<{ item: HeaderItem }> = ({ item }) => {
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const path = usePathname();
  const handleMouseEnter = () => {
    if (item.submenu) {
      setSubmenuOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setSubmenuOpen(false);
  };
  let navString

  const counterLetter = item.label.slice(-1);
  if(counterLetter === "s"){
    navString = item.label.toLowerCase().substring(item.label.length -1, - 1);
  }else{
    navString = item.label.toLowerCase();
  }

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        href={item.href}
        className={`text-[15px] flex font-medium hover:text-midnight_text  py-[15px] ${item.submenu ? "-my-[1px]" : ''} px-6 ${path.startsWith(`/${navString}`) ? "text-midnight_text! bg-white" : null} ${
          path === item.href ? "text-midnight_text bg-white" : " text-white "
        }`}
      >
        {item.label}
        {item.submenu && (  <ChevronDown size={20} className="top-[4px] relative" />
        )}
      </Link>
      {submenuOpen && (
        <div
          className={`absolute py-2 left-0 top-12 mt-0.5 w-60 bg-white shadow-lg rounded-lg `}
          data-aos="fade-up"
          data-aos-duration="500"
        >
          {item.submenu?.map((subItem, index) => (
            <Link
              key={index}
              href={subItem.href}
              className={`block px-4 py-2 text-[15px]  ${
                path === subItem.href
                  ? "bg-primary text-white"
                  : "text-black hover:bg-gray-200 hover:text-dark"
              }`}
            >
              {subItem.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default HeaderLink;
